import React from 'react';
import { Tab, Tabs, Text } from 'ui';
import { useTranslation } from 'react-i18next';
import ToConnectionRequestState from 'components/ToConnectionRequestState';
import { Modal } from '../../../../components';
import { KoobButton } from '@koob/ui';
import { useState } from 'react';
import { Stack } from '@koob/margaret';
import DenyExplainationForm from './DenyExplainationForm';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { ConnectionTypeEnum } from '@koob/enums';
import ToConnectionRequestStateEnum from 'constants/enums/ToConnectionRequestStateEnum';

const CustomTab = styled(Tab)`
  & {
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.12);
  }
`;

export default function Header({
  request,
  save,
  isLoading,
  isAllowedToManage,
  selectedDistributionOrganization,
}) {
  const { t } = useTranslation('toConnectionRequest');
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isAcceptHidden =
    request?.state === ToConnectionRequestStateEnum.CONFIRMED ||
    request?.state === ToConnectionRequestStateEnum.REFUSED;
  const isDenyHidden = request?.state === ToConnectionRequestStateEnum.REFUSED;

  const getConnectionType = () => {
    if (location.pathname.includes('/hotels')) return ConnectionTypeEnum.HOTELS;
    if (location.pathname.includes('/experiences'))
      return ConnectionTypeEnum.EXPERIENCES;
    if (location.pathname.includes('/templates'))
      return ConnectionTypeEnum.TEMPLATES;

    const requestType = `${request?.type?.toLowerCase()}s`;
    const connectionTypes = Object.values(ConnectionTypeEnum);

    return connectionTypes.includes(requestType)
      ? requestType
      : ConnectionTypeEnum.HOTELS;
  };

  const connectionType = getConnectionType();
  const requestId = request?.id;

  const refuse = () => {
    if (!window.confirm(t('denyConfirmation'))) {
      return;
    } else {
      setIsOpen(true);
    }
  };

  return (
    <div className="bg-white border rounded-lg p-10">
      <div className="flex justify-center">
        <div className="flex gap-4 text-black text-3xl">
          <h1>
            {selectedDistributionOrganization
              ? selectedDistributionOrganization?.label
              : request?.dmcOrganization?.name}
          </h1>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-10 h-10"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"
            />
          </svg>

          <h1>{request?.toOrganization?.name}</h1>
        </div>
      </div>

      <div className="flex justify-between">
        <div className={isDenyHidden ? 'invisible' : ''}>
          <KoobButton
            onClick={() => refuse()}
            variant="secondary"
            disabled={isLoading || !isAllowedToManage}
          >
            {t('misc:deny')}
          </KoobButton>
        </div>

        <div className="text-center">
          <Text type="h1">{t('config')}</Text>
        </div>

        <div className={isAcceptHidden ? 'invisible' : ''}>
          <KoobButton
            onClick={() => save('confirmed', '')}
            disabled={isLoading || !isAllowedToManage}
            variant="primary"
          >
            {t('misc:accept')}
          </KoobButton>
        </div>
      </div>

      <div className="mt-4 flex justify-center">
        <ToConnectionRequestState state={request?.state} />
      </div>

      {requestId && (
        <div className="mt-6 pt-4 border-t">
          <Tabs>
            <CustomTab
              to={`/to-connection-request/connections/${requestId}/${connectionType}`}
              end
            >
              {connectionType === 'hotels' && t('hotelSetting')}
              {connectionType === 'experiences' && t('experienceSetting')}
              {connectionType === 'templates' && t('templateSetting')}
            </CustomTab>
            <CustomTab
              to={`/to-connection-request/connections/${requestId}/history`}
            >
              {t('history', 'History')}
            </CustomTab>
          </Tabs>
        </div>
      )}

      {isOpen && (
        <Modal
          isOpen
          onRequestClose={() => {
            setIsOpen(false);
          }}
          title={
            <Stack size="full" alignY="center" gutterSize={1}>
              <p>{t('denyReason')}</p>
            </Stack>
          }
        >
          <DenyExplainationForm
            onSubmit={(values) => save('refused', values)}
          />
        </Modal>
      )}
    </div>
  );
}
